import { CustomerBillingInvoiceModel } from './customer-billing-invoice.model';
import { ListData } from '@fi-app/components/items-list/list-data.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '@fi-app/components/items-list/items-list-header';
import { InvoiceStatusType, InvoiceType } from './invoice-type';
import { Injector } from '@angular/core';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { CustomerBillingHelperService } from '@fi-app/customer-billing/customer-billing-helper.service';
import { getPriceWithSeprator } from '@fi-shared/utils/get-price-with-separator';
import { InvoiceStatusListItemComponent } from '@fi-app/customer-billing/customer-billing-invoice/invoice-status-list-item/invoice-status-list-item.component';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

export class CustomerBillingInvoiceListData extends ListData<CustomerBillingInvoiceModel> {
    constructor(injector: Injector) {
        super(injector, undefined, 'CustomerName');

        const customerBillingHelperService = injector.get(CustomerBillingHelperService);

        this.ShowDelete = false;
        this.ObjectType = ObjectTypes.CustomerBillingInvoice;

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.invoice'),
                'Id',
                new ItemsListHeaderProperties('InvoiceListId CcmListItem-Name', true, ItemsListElementType.A, {
                    Sref: FiStateNames.CustomerBilling.Invoice.View,
                    SrefParams: (data) => ({ Id: data.Id }),
                    mobileSubText: (data) => {
                        return (
                            data.CustomerName +
                            ', ' +
                            injector.get(FiFormatDateService).formatDate(data.InvoiceDate, 'date') +
                            ', ' +
                            data.TotalAmountExcVat.toFixed(2)
                        );
                    },
                }),
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.customer'),
                'CustomerName',
                new ItemsListHeaderProperties('', true, ItemsListElementType.A, {
                    Sref: FiStateNames.CustomerBilling.Invoice.View,
                    SrefParams: (data) => ({ Id: data.Id }),
                }),
            ),
        );

        //this.addSpanPlainHeader(this.appTextService.get('common.customer'), 'CustomerName');

        this.addSpanPlainHeader(
            this.appTextService.get('customer_billing.invoice_type'),
            'InvoiceType',
            '',
            true,
            (data, property) => {
                return this.appTextService.get(
                    data[property] == InvoiceType.Monthly ? 'customer_billing.monthly' : 'customer_billing.other',
                );
            },
        );

        this.addSpanPlainHeader(
            this.appTextService.get('billing.sum_excl_vat'),
            'TotalAmountExcVat',
            '',
            true,
            (data: CustomerBillingInvoiceModel, property) => {
                return getPriceWithSeprator(
                    customerBillingHelperService.getInvoiceTotalAmountExcVat(data.InvoiceDetails),
                );
            },
        );

        this.addSpanPlainHeader(
            this.appTextService.get('billing.sum_incl_vat'),
            'TotalAmountIncVat',
            '',
            true,
            (data: CustomerBillingInvoiceModel, property) => {
                return getPriceWithSeprator(
                    customerBillingHelperService.getInvoiceTotalAmountIncVat(data.InvoiceDetails, data.ChargeVAT),
                );
            },
        );

        this.addSpanPlainHeader(
            this.appTextService.get('billing.invoice_date'),
            'InvoiceDate',
            '',
            true,
            this.formatDate.bind(this),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('billing.print_status'),
                'InvoiceStatusType',
                new ItemsListHeaderProperties('', true, InvoiceStatusListItemComponent, {
                    headData: {
                        columnStatusType: InvoiceStatusType.Printed,
                    },
                }),
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('billing.send_status'),
                'InvoiceStatusType',
                new ItemsListHeaderProperties('', true, InvoiceStatusListItemComponent, {
                    headData: {
                        columnStatusType: InvoiceStatusType.Sent,
                    },
                }),
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('billing.pay_status'),
                'InvoiceStatusType',
                new ItemsListHeaderProperties('', true, InvoiceStatusListItemComponent, {
                    headData: {
                        columnStatusType: InvoiceStatusType.Paid,
                    },
                }),
            ),
        );

        this.addSpanPlainHeader(
            this.appTextService.get('common.expired'),
            'Expired',
            '',
            false,
            this.formatDate.bind(this),
        );

        this.getRowClass = (invoice: CustomerBillingInvoiceModel) => {
            const result = [];

            if (invoice.InvoiceStatusType == InvoiceStatusType.Generated) {
                result.push('invoice-not-sent');
            } else if (invoice.InvoiceStatusType == InvoiceStatusType.Sent) {
                result.push('invoice-sent');
            }

            result.push(invoice.InvoiceStatusType == InvoiceStatusType.Paid ? 'invoice-payed' : 'invoice-not-payed');

            if (invoice.DueDate && new Date(invoice.DueDate) < new Date()) result.push('invoice-expired');

            return result.join(' ');
        };
    }

    private formatDate(data, property) {
        return data[property] ? this.injector.get(FiFormatDateService).formatDate(data[property], 'date') : '-';
    }
}
